module.exports = __webpack_public_path__ + "static/media/workshoporganizersicra25.5a0635f7.jpeg";